import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"id":"axis-select","item-text":"nome","item-name":"grupoId","items":_vm.groups.grupos,"label":_vm.name,"placeholder":"Grupo","disabled":_vm.disabled,"return-object":true},on:{"change":function($event){return _vm.$emit('onChange')}},model:{value:(_vm.filter.grupo),callback:function ($$v) {_vm.$set(_vm.filter, "grupo", $$v)},expression:"filter.grupo"}},[_c('template',{slot:"no-data"},[_vm._v(" Nenhum Grupo retornado ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }